import { Chip, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import colors from 'common/constants/colors';
import { CATALOG_DISABLED_LABEL, CATALOG_DISABLED_TOOLTIP } from 'common/constants/catalogStatus';

// POM-6306: a catalog product disabled for ordering is still selectable wherever a user is working
// an order that already exists, so the marker has to read as information rather than as a refusal —
// hence the info icon rather than a block. A chip beside the Product ID also keeps the option row
// the same height as an enabled one; spelling it out in the Product ID line made the disabled rows
// visibly longer than the rest of the list.
const CatalogStatusChip = () => (
  <Tooltip title={CATALOG_DISABLED_TOOLTIP} arrow placement='top'>
    {/* Coloured from the palette rather than with color='warning': this theme maps
        palette.warning.main to perfectRxBlue, so the MUI shorthand renders a BLUE chip — which
        reads as a link inside a list whose rows are themselves clickable. The amber is in
        colors. */}
    <Chip
      size='small'
      variant='outlined'
      icon={<InfoOutlinedIcon sx={{ color: `${colors.warningAmberText} !important` }} />}
      label={CATALOG_DISABLED_LABEL}
      sx={{
        ml: 1,
        alignSelf: 'center',
        whiteSpace: 'nowrap',
        color: colors.warningAmberText,
        borderColor: colors.warningAmberBorder,
        backgroundColor: colors.warningAmberLight,
      }}
    />
  </Tooltip>
);

export default CatalogStatusChip;
